import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extraction-demnade-par-profil',
  templateUrl: './extraction-demnade-par-profil.component.html',
  styleUrls: ['./extraction-demnade-par-profil.component.scss']
})
export class ExtractionDemnadeParProfilComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
